import React, { CSSProperties } from "react";

interface Props {
  onClick?: () => void;
  children: any;
  style?: CSSProperties;
}

export default function SecondaryButton({ onClick, children, style }: Props) {
  return (
    <div
      className="secondary-button"
      onClick={onClick}
      role="button"
      style={style}
    >
      {children}
    </div>
  );
}
